/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as r}from"../../../../webgl/Uniform.js";class s extends r{constructor(r,s,t,e){super(r,"mat4",2,(t,o,m,c)=>t.setUniformMatrices4fv(r,s(o,m,c),e),t)}}export{s as Matrix4sDrawUniform};
